import {requestUser} from '@/utils/request'

// 获取验证码
export function getCodeImg() {
  return requestUser({
    url: '/captcha/image',
    method: 'post',
  })
}

// 邮箱 密码登录
export function loginByPassword(data) {
  return requestUser({
    url: '/seller/emailPasswordLogin',
    method: 'post',
    data,
  })
}

// 手机号 验证码登录
export function loginByVerificationCode(data) {
  return requestUser({
    url: '/seller/phoneCaptchaLogin',
    method: 'post',
    data
  });
}

// 查询卖家关联的货架
export function userAssociationShelfList(data) {
  return requestUser({
    url: '/staffShelfRelation/selectShelfList',
    method: 'post',
    data
  });
}

// 选择登录的店铺
export function chooseShop(data) {
  return requestUser({
    url: '/seller/chooseShop',
    method: 'post',
    data
  });
}

// 获取用户信息
export function getInfo(data) {
  return requestUser({
    url: '/seller/info',
    method: 'post',
    data
  })
}

// 完善邮箱和密码
export function saveEmailPassword(data) {
  return requestUser({
    url: '/seller/saveEmailPassword',
    method: 'post',
    data
  })
}

// 登出
export function logout(data) {
  return requestUser({
    url: '/seller/logout',
    method: 'post',
    data
  })
}

// 用户列表
export function getPlatformUser(data) {
  return requestUser({
    url: '/platformUser/selectList',
    method: 'post',
    data
  })
}

// 用户列表 分页
export function fetchList(data) {
  return requestUser({
    url: '/user/page',
    method: 'post',
    data
  })
}

// 新增
export function addUser(data) {
  return requestUser({
    url: '/user/save',
    method: 'post',
    data
  })
}

export function userUpdateOperator(data) {
  return requestUser({
    url: '/user/updateOperator',
    method: 'post',
    data
  })
}

export function userSaveOperator(data) {
  return requestUser({
    url: '/user/saveOperator',
    method: 'post',
    data
  })
}

// 修改用户
export function updateAdmin(data) {
  return requestUser({
    url: '/user/update',
    method: 'post',
    data
  })
}

// 根据Id查询
export function getInfoById(data) {
  return requestUser({
    url: '/seller/selectOne',
    method: 'post',
    data
  })
}

// 重置密码
export function resetPassword(data) {
  return requestUser({
    url: '/user/resetPassword',
    method: 'post',
    data
  })
}

/**
 *     "id": "",
 *     "username": "",
 *     "email": "",
 *     "phoneAreaCode": "",
 *     "phoneCountryCode": "",
 *     "phone": ""
 * @param data
 * @returns {response}
 * 校验是否唯一
 */
export function checkUnique(data) {
  return requestUser({
    url: '/seller/checkUnique',
    method: 'post',
    data
  })
}

/**
 * 重置密码-校验是否存在该用户
 */
export function checkUniqueResetPassword(data) {
  return requestUser({
    url: '/seller/existInResetPassword',
    method: 'post',
    data
  })
}

/**
 * 更新邮箱/密码--校验是否存在该用户
 */
export function checkUniqueUpdatePhoneEmail(data) {
  return requestUser({
    url: '/seller/existInUpdatePhoneEmail',
    method: 'post',
    data
  })
}

// 获取手机验证码
export function sendPhoneCode(data) {
  return requestUser({
    url: `/captcha/sendPhoneCode`,
    method: 'post',
    data
  })
}

// 获取邮箱验证码
export function sendEmailCode(data, options = {}) {
  return requestUser({
    url: `/captcha/sendEmailCode`,
    method: 'post',
    data,
    ...options
  })
}

// 校验验证码并重置密码
export function resetPass(data) {
  return requestUser({
    url: `/seller/checkCodeAndResetPassword`,
    method: 'post',
    data
  })
}

// 二次认证
export function loginSecondAuth(data) {
  return requestUser({
    url: `/seller/secondAuth`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js